import WarpElement from '@warp-ds/elements-core';
import { css, html, TemplateResult } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { trackPhone, trackShowPhone } from '../utils/pulseTrackingUtils.js';
import '@warp-ds/elements/components/button';
import { i18n } from '@lingui/core';
import { Phone } from '../../server/types.js';
import '@warp-ds/icons/elements/check-16';
import '@warp-ds/elements/components/toast';
//@ts-expect-error missing types
import { toast } from '@warp-ds/elements/toast';

@customElement('phonenumber-button')
export class PhoneNumberButton extends WarpElement {
	@property({ type: String }) variant!: string;
	@property({ type: Array }) phone!: Phone;
	@property({ type: String }) deviceType?: string;
	@property({ type: String }) adId!: string;
	@property({ type: String }) orgName!: string;
	@property({ type: Function }) focusHandler: () => void = () => {};

	@state()
	private phoneHidden = true;
	@state()
	private text: TemplateResult | string = i18n.t({
		id: 'show.phone.number',
		message: 'Show phone number',
	});

	// Copied from the interwebz
	copyToClipboard = async (textToCopy: string) => {
		if (navigator.clipboard && window.isSecureContext) {
			await navigator.clipboard.writeText(textToCopy);
		} else {
			const textArea = document.createElement('textarea');
			textArea.value = textToCopy;

			textArea.style.position = 'absolute';
			textArea.style.left = '-999999px';

			document.body.prepend(textArea);
			textArea.select();

			try {
				document.execCommand('copy');
			} catch (error) {
				console.error(error);
			} finally {
				textArea.remove();
			}
		}
	};

	onDesktopClick = () => {
		if (this.phoneHidden) {
			trackShowPhone(this.orgName);
			this.phoneHidden = false;
			this.text = this.phone.phoneFormatted;
		} else {
			this.copyToClipboard(this.phone.phoneAsLink.replace('tel:', ''));
			toast(
				i18n.t({
					id: 'show.phone.number.copied',
					message: 'Copied',
				}),
			);
		}
	};

	static styles = [
		...WarpElement.styles,
		css`
			@css-placeholder-5f3Pid;
		`,
	];

	render() {
		const cssClass = 'flex-1 md:flex-none md:min-w-[170px]';
		const isMobileDevice =
			this.deviceType === 'mobile' || this.deviceType === 'tablet';

		if (isMobileDevice) {
			return html`
				<w-button
					variant=${this.variant}
					full-width
					class=${cssClass}
					href="${this.phone.phoneAsLink}"
					@click="${() => trackPhone(this.adId, this.orgName)}"
					@focus=${this.focusHandler}
				>
					${i18n.t({
						id: 'show.phone.call',
						message: 'Call seller',
					})}
				</w-button>
			`;
		}

		return html`
			<w-button
				class=${cssClass}
				full-width
				variant=${this.variant}
				@focus=${this.focusHandler}
				@click="${this.onDesktopClick}"
			>
				${this.text}
			</w-button>
		`;
	}
}
